import React, { useState, useEffect } from 'react';
import cookies from 'js-cookie';
import App from './App';
import { LoadingSpinner } from './common/loading-spinner/LoadingSpinner';
import LoginErrorPage from './LoginErrorPage';
import { getUserStatus, setAuthToken as setApiToken } from '../services/api/api';
import config from '../services/config';
import { setEnabledFeatureFlags } from '../services/feature-flags';
import { setAuthToken as setDeepstreamToken } from '../services/deepstream';
import { goToLoginPage } from '../services/cognito/cognito';
import { useCurrentUserState } from '../services/state';

const LoginGate = () => {
  const [loading, setLoading] = useState(true);
  const [errorHappened, setErrorHappened] = useState(false);
  const userState = useCurrentUserState();

  async function loadUserStatus() {
    const urlSearchParams = new URL(window.location.href).searchParams;
    const authCode = urlSearchParams.get('code') || '';
    const redirectPath = urlSearchParams.get('state') || '/boards';

    const storedRefreshToken = cookies.get(config.cookieName) || '';
    const redirectUrl = `${window.location.origin}${config.cognitoRedirectPath}`;

    try {
      const { isLoggedIn, userId, userEmail, token, refreshToken, featureFlags } =
        await getUserStatus({
          authCode,
          refreshToken: storedRefreshToken,
          redirectUrl
        });

      if (!isLoggedIn) {
        cookies.remove(config.cookieName);
        goToLoginPage(window.location.pathname);
        return;
      }

      cookies.set(config.cookieName, refreshToken, { expires: config.cookieExpirationInDays });
      setApiToken(token);
      setDeepstreamToken(token);
      setEnabledFeatureFlags(featureFlags);

      if (window.location.pathname.startsWith(config.cognitoRedirectPath)) {
        window.history.pushState(null, null, redirectPath);
      }

      userState.set({ id: userId, email: userEmail });
      setLoading(false);
    } catch (error) {
      console.log(error);
      setErrorHappened(true);
      setLoading(false);
    }
  }

  useEffect(() => {
    loadUserStatus();
  }, []);

  if (errorHappened) return <LoginErrorPage />;
  if (loading) return <LoadingSpinner />;
  return <App />;
};

export default LoginGate;
